import { DestroyOffscreenMessage, OffscreenMessage, OffscreenTextureNeedsUpdateMessage } from "../../messages/offscreen/OffscreenMessages";
import { busService } from "../bus";
import { OffscreenNetworkStatsRenderer } from "./OffscreenNetworkStatsRenderer";
import { PendingMessages } from "flavr-common";
export class OffscreenRenderService {
    constructor() {
        this.renderers = new Map();
        this.connection = busService.connection("OffscreenRenderService");
        this.rendererFactoryMap = new Map();
        this.isReady = false;
        this.pendingMessages = new PendingMessages();
        this.worldContainer = null;
        this.gl = null;
        this.draw = (time) => {
            // Update canves dimensions before drawing to prevent flickering when size changes
            this.updateCanvasDimensions();
            for (const [id, renderer] of this.renderers) {
                if (renderer.draw(time)) {
                    this.pendingMessages.push(new OffscreenTextureNeedsUpdateMessage(id));
                }
            }
            if (this.pendingMessages.hasMessages()) {
                this.connection.sendMultiple(this.pendingMessages.get());
                this.pendingMessages.clear();
            }
            if (this.renderers.size > 0) {
                this.animationHandle = self.requestAnimationFrame(this.draw);
            }
        };
        this.handleOffscreenMessage = (msg) => {
            const canvas = msg.offscreen;
            const context = canvas.getContext("2d"); /* as OffscreenCanvasRenderingContext2D */
            const creator = this.rendererFactoryMap.get("NetworkStats");
            if (!creator) {
                return;
            }
            const renderer = new creator(canvas, context);
            this.renderers.set(msg.id, renderer);
            this.startDrawing();
        };
        this.handleDestroyOffscreenMessage = (msg) => {
            this.renderers.delete(msg.id);
            this.worldContainer = null;
            this.gl = null;
        };
    }
    init() {
        if (this.isReady)
            return;
        this.rendererFactoryMap.set("NetworkStats", OffscreenNetworkStatsRenderer);
        this.connection.subscribeByType(OffscreenMessage, this.handleOffscreenMessage);
        this.connection.subscribeByType(DestroyOffscreenMessage, this.handleDestroyOffscreenMessage);
        this.stopDrawing();
        this.isReady = true;
    }
    startDrawing() {
        if (this.animationHandle !== undefined)
            return;
        this.animationHandle = self.requestAnimationFrame(this.draw);
    }
    stopDrawing() {
        if (this.animationHandle === undefined)
            return;
        self.cancelAnimationFrame(this.animationHandle);
        this.animationHandle = undefined;
        this.worldContainer = null;
        this.gl = null;
    }
    updateCanvasDimensions() {
        var _a, _b, _c, _d, _e, _f;
        if (!this.worldContainer) {
            this.worldContainer = document.getElementById("world-container");
        }
        if (!this.gl) {
            this.gl = (_b = (_a = this.worldContainer) === null || _a === void 0 ? void 0 : _a.getElementsByTagName("canvas")[0]) === null || _b === void 0 ? void 0 : _b.getContext("webgl");
        }
        if (this.gl) {
            this.gl.canvas.width = (_d = (_c = this.worldContainer) === null || _c === void 0 ? void 0 : _c.offsetWidth) !== null && _d !== void 0 ? _d : window.innerWidth;
            this.gl.canvas.height = (_f = (_e = this.worldContainer) === null || _e === void 0 ? void 0 : _e.offsetHeight) !== null && _f !== void 0 ? _f : window.innerHeight;
        }
    }
}
